import { mobileFormTypes } from '../../../../components/mobileForm/hooks/useExtendedFormActions';
import useMobileForm from '../../../../components/mobileForm/hooks/useMobileForm';

const useAssetsExtendedForm = ({ idApp, values, getApplicationForm }) => {
  const reviewFormData = useMobileForm({ idApp, values, getApplicationForm, itemType: mobileFormTypes.asset });

  return reviewFormData;
};

export default useAssetsExtendedForm;
